import React from 'react';
import { GatewayPlan, formatPlanPrice } from '../../services/api/paymentApi';

/** One-line "Plan name  ₹499 / Month" summary of a gateway plan. */
const PlanDetails: React.FC<{ plan: GatewayPlan; heading?: string }> = ({ plan, heading }) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 12,
      flexWrap: 'wrap',
      fontSize: '0.85rem',
      background: '#f4f7fb',
      border: '1px solid #e1e8f2',
      borderRadius: 10,
      padding: '8px 12px',
    }}
  >
    <span style={{ color: '#555' }}>
      {heading && <span style={{ color: '#888' }}>{heading} · </span>}
      <strong style={{ color: '#222' }}>{plan.name}</strong>
    </span>
    {formatPlanPrice(plan) && (
      <strong style={{ color: '#0d47a1' }}>{formatPlanPrice(plan)}</strong>
    )}
  </div>
);

export default PlanDetails;
